export function sliceValue(value: string | number) {
  const stringValue = value.toString();
  if (stringValue.length > 2) {
    return stringValue.slice(0, 2);
  }
  return value;
}
